export default __webpack_public_path__ + "static/images/lisa_04.png";